import React, { useState, useEffect } from 'react';
import RadioButton from 'components/RadioButton';
import PropTypes from 'prop-types';
import style from './style.scss';//NOSONAR
import PubSub from 'services/PubSub';

let actions = {};

const ItemStore = ({store, storeSelected, customOnClick}) => {
    const [open, setOpen] = useState(false);
    const method = storeSelected ? storeSelected.method : null;
    const selectMethod = (method) => {
        customOnClick(store, method);
    }
    if(!store) return '';

    useEffect(()=> {
        if(store.disabled){
            setOpen(false);
        }
    },[store.disabled]);

    useEffect(() => {
        if (!actions[store.value]) {
            actions[store.value] = [];

        }
        actions[store.value].push(PubSub.register('item_store_open',openItem));

        return function cleanup(){
            actions[store.value].map((token) => PubSub.unregister(token));
            actions[store.value] = [];
        }
    },[]);
    const openItem = (payload) => {
        if(!(payload && payload.value)) return false;
        const itemSelected = payload.value.value;
        if(itemSelected !== store.value){
            setOpen(false);
        }
    }

    const _open = (value) => {
        if(value) PubSub.dispatch('item_store_open', {value: store.value})
        setOpen(value);
    }
    const currentSelected = storeSelected ? (storeSelected.value === store.value) : false;

    return (<li className={"store-item-wrap" + (store.disabled ? ' disabled' : '')}>
        {store.saved && <span className="store-item-frequently">Local frecuente</span>}
        <span className="store-item-title" onClick={() => {_open(!open);}}>{store.name}</span>
        <span className="store-item-address" onClick={() => {_open(!open);}}>{store.address || ''}</span>
        <span className={"store-item-radio-buttons" + (((open || currentSelected) && !store.disabled) ? ' open' : '')}>
            {store.auto && <div className="store-item-radio" onClick={()=>selectMethod('auto')}>
                <RadioButton item={currentSelected && (method === 'auto')}/>
                <span className="store-item-radio-title">Retira en el Auto</span>
            </div>}
            {store.store && <div className="store-item-radio" onClick={() => selectMethod('store')}>
                <RadioButton item={currentSelected && (method === 'store')}/>
                <span className="store-item-radio-title">Retira en el Local</span>
            </div>}
                
        </span>
    </li>)
}

ItemStore.propTypes = {
    store: PropTypes.object,
    storeSelected: PropTypes.object,
    customOnClick: PropTypes.func
};
export default ItemStore;
